import React from 'react';
import { Center, Text, VStack } from '@wegroup/design-system';
import Lottie from 'lottie-react';
import animation from '../../assets/lottie/doc-extraction-files.json';
import { useTranslation } from 'react-i18next';

interface Props {
  title?: string;
  description?: string;
}

const DocumentExtractionLoading: React.FC<Props> = ({ title, description }) => {
  const { t } = useTranslation();

  return (
    <Center w="full" h="100%">
      <VStack maxW="lg" spacing="4">
        <Lottie animationData={animation} loop={true} />
        <VStack spacing="2">
          <Text textStyle="normalBodyMedium">
            {title || t('DOCUMENT-EXTRACTION_LOADING')}...
          </Text>
          <Text textStyle="smallBody" color="gray.500">
            {description || t('DOCUMENT-EXTRACTION_LOADING_DESCRIPTION')}
          </Text>
        </VStack>
      </VStack>
    </Center>
  );
};

export default DocumentExtractionLoading;
